var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBlock)?_c('div',{staticClass:"two-row__cell"},[_c('p',{staticClass:"row-one"},[_vm._v(_vm._s(_vm.firstRow))]),_vm._v(" "),_c('p',{staticClass:"row-two"},[_vm._v(_vm._s(_vm.secondRow))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }